import { getStaticOptions, localStorageTest } from "../../utils";
import { LOCAL_STORAGE_KEY_QUEUE_NOTIFY_WORKER_PREFIX } from ".";
/**
 * Check existing worker notifications and execute a given callback.
 */ function checkWorkerNotifications(callbacks) {
    if (localStorageTest()) {
        const lsPrefix = `${LOCAL_STORAGE_KEY_QUEUE_NOTIFY_WORKER_PREFIX}${getStaticOptions().localStorageSuffix}`;
        for (const lsEntryName of Object.keys(localStorage)){
            if (lsEntryName.startsWith(lsPrefix)) {
                var _callbacks_event;
                const { event, data } = JSON.parse(localStorage.getItem(lsEntryName));
                localStorage.removeItem(lsEntryName);
                (_callbacks_event = callbacks[event]) == null ? void 0 : _callbacks_event.call(callbacks, data);
            }
        }
        return true;
    }
    return false;
}
export { checkWorkerNotifications };
